import { Component, OnInit } from '@angular/core';
import { MapModel } from '../models/MapModel';
import { MapDetailsServerList } from '../models/MapDetailsServerList';
import { MapDetailsList } from '../models/MapDetailsList';
import { MapDetailOstalo } from '../models/MapDetailsOstalo';
import { MapDetailsServer } from '../models/MapDetailsServer';
import { MonitorService } from '../services/delavci/monitor/monitor.service';
import { MainService } from '../services/delavci/main.service';
import { faSkull } from '@fortawesome/free-solid-svg-icons';

import {MatLegacySnackBar as MatSnackBar} from '@angular/material/legacy-snack-bar';
@Component({
  selector: 'app-monitor-item',
  templateUrl: './monitor-item.component.html',
  styleUrls: ['./monitor-item.component.css']
})
export class MonitorItemComponent implements OnInit {

  public databaseSelected = true;
  public mapDetailsServerList: MapDetailsServerList;
  public mapDetailsList: MapDetailsList;
  public tableRow: MapModel;
  public spinner: boolean;
  /* kill */
  public selectedDetailsServerRow: MapDetailsServer;
  public selectedDetailsMonitorRow: MapDetailOstalo;
  public kill = false;
  public killM = false;
  /* konec kill */
  faSkull = faSkull;

  public isVALUE_SPLITTED = false;
  constructor(private monitorService: MonitorService, private mainService: MainService, private _snackBar: MatSnackBar) { }

  ngOnInit() {
    this.spinner = true;
    this.tableRow = this.monitorService.currentTableRowValue;
    if (this.tableRow.MODU_NAMESMALL === "BO_SERVER") {
      this.databaseSelected = false;
      this.mapDetailsList = undefined;
      this.monitorService.monitorGetDetailsServer(this.tableRow.SERV_ADDRESSINTERNAL, this.tableRow.SERV_DBPORT).subscribe(data => {
        this.spinner = false;
        this.mapDetailsServerList = data;
      }, error => {
        console.log(error);
        this.spinner = false;
      }, () => {

      });
    } else  {
      this.databaseSelected = true;
      this.monitorService.monitorGetDetailsOstali(this.tableRow.SERV_HOSTNAME, this.tableRow.METHOD).subscribe(data => {
        this.spinner = false;
        this.mapDetailsList = data;
        for(let i = 0; i < this.mapDetailsList.items.length; i++) {
          let stringSplitter =  this.mapDetailsList.items[i].VALUE.split(";");
          //sliceam zadnjo mesto, saj je na zadnjem mestu prazen string

          this.mapDetailsList.items[i].VALUE_SPLITTED = stringSplitter.slice(0, stringSplitter.length-1);
          if(this.mapDetailsList.items[i].VALUE_SPLITTED.length != 0){
            this.isVALUE_SPLITTED = true;
          }else {
            this.isVALUE_SPLITTED = false;
          }
        }
      }, error => {
        console.log(error);
        this.spinner = false;
        }
        , () => {});
    }
  }

// klik na gumb rešujem, to mapo da v "gray" tabelo in s tem postaneš "working user"
resujem() {
  this.monitorService.buttonResujem(this.tableRow.KEY, this.tableRow.MODU_NAMESMALL,
    this.tableRow.SERV_NAMESMALL, this.tableRow.METHOD, this.tableRow.VALUE
    , this.mainService.currentUsernameValue).subscribe(data =>  {
     // this.updateTable();
      this._snackBar.open(this.mainService.currentUserValue.workerNameSmall + ' rešuje', 'Zapri', {
        duration: 2000,
      });
  }, error => {
    console.log(error);
  }, () => {

  });
}

// funkcija, ki osvežuje tabelo
osvezi() {
/* namesto tega lahk tu kličem table pa poiščem ta row*/
if (this.tableRow.MODU_NAMESMALL === "BO_SERVER") {
  this.databaseSelected = false;
  this.mapDetailsList = undefined;
  this.monitorService.monitorGetDetailsServer(this.tableRow.SERV_ADDRESSINTERNAL, this.tableRow.SERV_DBPORT).subscribe(data => {
    this.spinner = false;
    this.mapDetailsServerList = data;
    this._snackBar.open('Osveženo', 'Zapri', {
      duration: 500,
    });
  }, error => {
    console.log(error);
    this.spinner = false;
  }, () => {
  });
} else  {
  this.databaseSelected = true;
  this.monitorService.monitorGetDetailsOstali(this.tableRow.SERV_HOSTNAME, this.tableRow.METHOD).subscribe(data => {
    this.spinner = false;
    this.mapDetailsList = data;
    for (let i = 0; i < this.mapDetailsList.items.length; i++) {
      let stringSplitter =  this.mapDetailsList.items[i].VALUE.split(";");
      // sliceam zadnjo mesto, saj je na zadnjem mestu prazen string
      this.mapDetailsList.items[i].VALUE_SPLITTED = stringSplitter.slice(0, stringSplitter.length-1);
      if (this.mapDetailsList.items[i].VALUE_SPLITTED.length != 0) {
        this.isVALUE_SPLITTED = true;
      } else {
        this.isVALUE_SPLITTED = false;
      }
    }
    this._snackBar.open('Osveženo', 'Zapri', {
      duration: 500,
    });
  }, error => {
    console.log(error);
    this.spinner = false;
    }
    , () => {});
}
}

// gumb konec, konča reševanje
konec() {
  this.monitorService.buttonKonec(this.tableRow.KEY).subscribe(data =>  {
  this._snackBar.open('Reševanje končano', 'Zapri', {
    duration: 2000,
  });
  }, error => {
    console.log(error);
  }, () => {
  });
}

  // on click listener za kill server
  onServerClick(list) {
    if (this.kill === false) {
      this.selectedDetailsServerRow = list;
      this.kill = true;
    } else {
      this.kill = false;
    }
  }

 //Monitor kill za DA in ostalo
 onMonitorClick(list) {
  if(this.killM === false){
    this.selectedDetailsMonitorRow = list;
    this.killM = true;
  } else {
    this.killM = false;
  }
}

  killServer() {
      this.monitorService.killServer(this.selectedDetailsServerRow.username,
      this.tableRow.SERV_ADDRESSINTERNAL, this.tableRow.SERV_DBPORT).subscribe(data => {
        console.log(data);
      }, error => {
        console.log(error);
      });
  }

  killMonitor() {
    this.monitorService.killMonitor(this.tableRow.SERV_HOSTNAME, this.selectedDetailsMonitorRow.ID).subscribe(data => {
      console.log(data);
    }, error => {
      console.log(error);
    });
  }



  //pobarva številko, če je VALUE večji kot pa je AVG value v DA
  valueMoreThanAVG(parentAVG: string, thisAVG: string, i: string) {
    if (Number(i) === 0 && Number(parentAVG) < Number(thisAVG)) {
      return true;
    } else {
      return false;
    }
  }
}
